import styled, { css } from 'styled-components';
import { isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../../utils/mobileSupported';
import { getResponsiveValue } from '../../../../utils/globalMethods';
import {
  SeeProgressStepTooltipTopPosConditions,
  SeeProgressStepTooltipRightPosConditionsTablet,
  SeeProgressStepTooltipTopPosConditionsTablet,
} from './conditions';
import { Tooltip, ShadowLayer } from '..';

const isNotStandaloneMobilePWANotTablet = isNotStandaloneMobilePWA && !isTablet;

const tooltipSmallScreen = css`
  top: ${({ windowHeight }) =>
    getResponsiveValue({ windowHeight, conditions: SeeProgressStepTooltipTopPosConditions, defaultValue: 22 })}vh;
  right: calc(44vw - 610px);
`;

const tooltipSmallScreenTablet = css`
  right: ${({ windowHeight }) =>
    getResponsiveValue({
      windowHeight,
      conditions: SeeProgressStepTooltipRightPosConditionsTablet,
      defaultValue: 'calc(46vw - 610px)',
    })};
  top: ${isNotStandaloneMobilePWA
    ? `${({ windowHeight }) => getResponsiveValue({ windowHeight, conditions: SeeProgressStepTooltipTopPosConditionsTablet, defaultValue: 22 })}vh`
    : '106px'};
`;

const tooltipSmallScreenPWA = css`
  right: calc(44vw - 610px);
`;

export const EXPLORE = {
  TOOLTIP: styled(Tooltip)`
    width: 490px;
    top: 130px;
    right: calc(50vw - 610px);
    ${({ windowHeight }) => isNotStandaloneMobilePWANotTablet && tooltipSmallScreen}
    ${isStandalonePWA && !isTablet && tooltipSmallScreenPWA}
    ${({ windowHeight }) => isTablet && tooltipSmallScreenTablet}
  `,
  TOP: styled(ShadowLayer)`
    height: 100vh;
    width: 100vw;
    top: 0px;
    left: 0px;
  `,
};

